import { alliancePartners } from "@/mocks/bioconData";
import { StaggerContainer, StaggerItem } from "@/components/base/StaggerContainer";

export default function AlliancePartners() {
  return (
    <section className="py-12 bg-[#f6f9fc]">
      <div className="container mx-auto px-4">
        {/* Separator with text */}
        <div className="flex items-center gap-4 mb-8">
          <div className="flex-1 h-px bg-gray-200" />
          <h4 className="text-sm font-semibold text-[#2c4964] whitespace-nowrap uppercase tracking-wider">
            Biocon Alliance Company
          </h4>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        {/* Logo grid */}
        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {alliancePartners.map((p) => (
            <StaggerItem key={p.id}>
              <a
                href={p.link}
                rel="nofollow"
                target="_blank"
                className="group flex items-center justify-center bg-white rounded-xl border border-gray-200/50 hover:border-[#1977cc]/20 hover:shadow-md hover:-translate-y-0.5 transition-all duration-500 w-full h-[110px] md:h-[130px] px-6 py-4"
              >
                <img
                  src={p.image}
                  alt={p.alt}
                  className="max-h-full max-w-full object-contain transition-opacity duration-500 opacity-70 group-hover:opacity-100"
                />
              </a>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
